import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import Layout  from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret,faSearch,faList,faListUl,faThList,faGripVertical,faArchive,faExternalLinkSquareAlt,faCog, faSpinner, faListAlt, faDownload, faChartBar } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { BJumbotron } from 'bootstrap-vue'
import { ModelSelect } from 'vue-search-select'
import { Plotly } from 'vue-plotly'
import 'vue-search-select/dist/VueSearchSelect.css'
import ViewScrollTab from 'vue-scrolling-table'
import JsonCSV from 'vue-json-csv'
import ReadMore from 'vue-read-more';



Vue.use(BootstrapVue)
Vue.use(Layout)
Vue.use(ReadMore);
library.add(faUserSecret,faSearch,faList,faListUl,faThList,faGripVertical,faArchive,faExternalLinkSquareAlt,faCog,faSpinner,faListAlt,faDownload,faChartBar)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('b-jumbotron', BJumbotron)
Vue.component('model-select', ModelSelect)
Vue.component('Plotly', Plotly)
Vue.component('vue-scrolling-table',ViewScrollTab)
Vue.component('downloadCsv', JsonCSV)
Vue.config.productionTip = true

Vue.prototype.$hostname = (Vue.config.productionTip) ? '' : 'http://localhost:6004/'

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  render: h => h(App)
})
